import { render, staticRenderFns } from "./AlbumCD.vue?vue&type=template&id=2747d6b9&scoped=true&"
import script from "./AlbumCD.vue?vue&type=script&lang=js&"
export * from "./AlbumCD.vue?vue&type=script&lang=js&"
import style0 from "./AlbumCD.vue?vue&type=style&index=0&id=2747d6b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2747d6b9",
  null
  
)

export default component.exports